export default "__VITE_ASSET__b5e00211__"